<template>
	<svg :width="width" :height="height" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd"
			d="M5 30C5 43.775 16.225 55 30 55C43.775 55 55 43.775 55 30C55 16.225 43.775 5 30 5C16.225 5 5 16.225 5 30ZM30 18.125C31.025 18.125 31.875 18.975 31.875 20V32.5C31.875 33.525 31.025 34.375 30 34.375C28.975 34.375 28.125 33.525 28.125 32.5V20C28.125 18.975 28.975 18.125 30 18.125ZM31.775 41.775C31.525 42 31.25 42.175 30.95 42.3C30.65 42.425 30.325 42.5 30 42.5C29.675 42.5 29.35 42.425 29.05 42.3C28.75 42.175 28.475 42 28.225 41.775C28 41.525 27.825 41.275 27.7 40.95C27.575 40.65 27.5 40.325 27.5 40C27.5 39.675 27.575 39.35 27.7 39.05C27.825 38.75 28 38.475 28.225 38.225C28.475 38 28.75 37.825 29.05 37.7C29.65 37.45 30.35 37.45 30.95 37.7C31.25 37.825 31.525 38 31.775 38.225C32 38.475 32.175 38.75 32.3 39.05C32.425 39.35 32.5 39.675 32.5 40C32.5 40.325 32.425 40.65 32.3 40.95C32.175 41.275 32 41.525 31.775 41.775Z"
			:fill="color_prop" />
	</svg>

</template>

<script>
export default {

	name: 'IconInfo',

	props: {
		sizeMultiplier_prop: {
			type: Number,
			default: 1,
		},

		width_prop: {
			type: String,
			default: '3.75em', // "px" or "em" only
		},

		height_prop: {
			type: String,
			default: '3.75em', // "px" or "em" only
		},

		color_prop: {
			type: String,
			default: '#007BFF',
		}
	},

	data() {
		return {
		}
	},

	computed: {
		width() {
			// return Number(this.width_prop.substr(0, this.width_prop.length - 2)) * this.sizeMultiplier_prop + this.width_prop.substr(-2)
			const extracted = this.extractValueAndUnit(this.width_prop)
			return extracted.value * this.sizeMultiplier_prop + extracted.unit
		},

		height() {
			// return Number(this.height_prop.substr(0, this.height_prop.length - 2)) * this.sizeMultiplier_prop + this.height_prop.substr(-2)
			const extracted = this.extractValueAndUnit(this.height_prop)
			return extracted.value * this.sizeMultiplier_prop + extracted.unit
		},
	},

	methods: {
		// extract value and unit from a string. px, em, rem, %
		extractValueAndUnit(input) {
			const regex = /^([\d.]+)(px|em|rem|%)$/ // Matches numeric values with units
			const match = input.match(regex)

			if (match) {
				const value = parseFloat(match[1]) // Convert numeric part to a number
				const unit = match[2] // Extract unit part
				return { value, unit }
			}

			return { value: 0, unit: 'px' } // Default value
		}
	}
}
</script>

<style lang="css" scoped></style>